import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import MyProfile from "./index";
import EditMyProfile from "./edit";
import { User } from "lucide-react";

const myProfileRoutes = [	
	generateCRUDRoutes({
		mainTitle: "My Profile",
		basePath: "my/profile",
		mainComponent: <MyProfile />,
	    layout: "/my",
		icon: <User className="icon-item"/>,
	    subTitle:"My Profile",
		editComponent: <EditMyProfile />,
		level:4,
		moduleId: 0,
	}),
	{
		name: "My Profile",
	    layout: "/my",
	    path: "my/profile",
		path: `my/profile/:profileId/edit`,
	    component: <EditMyProfile />,
	    isMainMenu:false,
		moduleId: 0,
		level:4,
  	},
]

export default myProfileRoutes;